import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

export default function PracticePage({ kicker, title, lede, heroImg, sections, bullets, slug }) {
    return (
        <div data-testid={`practice-page-${slug}`}>
            <section className="relative bg-acre-bg">
                <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 pt-16 lg:pt-24 pb-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
                    <div className="lg:col-span-7 reveal">
                        <div className="text-[11px] uppercase tracking-[0.28em] text-acre-secondary mb-5">
                            {kicker}
                        </div>
                        <h1 className="font-serif-display text-5xl lg:text-7xl leading-[0.98] tracking-tight text-acre-secondary">
                            {title}
                        </h1>
                        <p className="mt-7 max-w-2xl text-base lg:text-lg leading-relaxed text-acre-muted">
                            {lede}
                        </p>
                        <div className="mt-8 flex flex-wrap gap-4">
                            <Link
                                to="/contact"
                                data-testid={`${slug}-cta-primary`}
                                className="group inline-flex items-center gap-2 bg-acre-primary text-white px-7 py-4 text-sm tracking-wide hover:bg-acre-primaryHover transition-all"
                            >
                                Book a Consultation
                                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                            </Link>
                            <a
                                href="tel:+19016412532"
                                data-testid={`${slug}-cta-call`}
                                className="inline-flex items-center text-acre-primary border border-acre-primary px-7 py-4 text-sm tracking-wide hover:bg-acre-primary hover:text-white transition-all"
                            >
                                (901) 641-2532
                            </a>
                        </div>
                    </div>
                    <div className="lg:col-span-5 reveal reveal-delay-2">
                        <div className="relative aspect-[4/5] overflow-hidden">
                            <img src={heroImg} alt={title} className="w-full h-full object-cover" />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-20 lg:py-28 bg-white border-y border-acre-line">
                <div className="max-w-[1200px] mx-auto px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <div className="text-[11px] uppercase tracking-[0.28em] text-acre-secondary mb-5">
                            What we handle
                        </div>
                        <h2 className="font-serif-display text-3xl lg:text-4xl text-acre-secondary leading-tight">
                            Practical scope, plainly described.
                        </h2>
                    </div>
                    <div className="lg:col-span-7">
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                            {bullets.map((b, i) => (
                                <li key={i} className="flex items-start gap-3 text-acre-ink py-3 border-b border-acre-line">
                                    <Check size={18} className="text-acre-primary mt-0.5 shrink-0" strokeWidth={1.75} />
                                    <span className="text-sm leading-relaxed">{b}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>

            <section className="py-20 lg:py-28">
                <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-16 space-y-16">
                    {sections.map((sec, i) => (
                        <div key={i} className="grid grid-cols-1 lg:grid-cols-12 gap-8">
                            <div className="lg:col-span-4">
                                <div className="font-serif-display text-acre-secondary text-2xl">0{i + 1}</div>
                                <h3 className="font-serif-display text-3xl text-acre-ink mt-2 leading-snug">{sec.h}</h3>
                            </div>
                            <div className="lg:col-span-8">
                                <p className="text-acre-muted text-base lg:text-lg leading-relaxed">{sec.p}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
